"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getT = exports.getTextResourceShared = exports.replaceTemplateVars = void 0;
const context_1 = require("./context");
function replaceTemplateVars(value, parse) {
    return value.replace(/\{\{(.*?)}}/g, (match, key) => {
        if (!parse || typeof parse[key] === 'undefined' || parse[key] === null) {
            throw new Error(`Missing prop: '${key}' in '${value}'`);
        }
        return parse[key];
    });
}
exports.replaceTemplateVars = replaceTemplateVars;
/**
 * Get text resources.
 * @param {ResourcesContextValue} context
 * @param {string} selector
 */
function getTextResourceShared(context, selector) {
    const resources = context.resources[selector];
    return Object.assign(Object.assign({}, context), { resources, t: (path, parse = {}) => {
            if (!resources) {
                return 'Loading...';
            }
            if (!resources[path]) {
                return resources[path];
            }
            return replaceTemplateVars(resources[path], parse);
        } });
}
exports.getTextResourceShared = getTextResourceShared;
/**
 * Regular function to get text resources.
 * @param {TextResources} selector
 */
function getT(selector) {
    const context = context_1.resourcesModel.getValue();
    return getTextResourceShared(context, selector);
}
exports.getT = getT;
//# sourceMappingURL=helpers.js.map